export const METAVERSE_APP = "Metaverse";

export class OfficeChromeMountError extends Error {}

export function officeChromeContexts(pageContexts, metaverseConfigurationId, q3poConfigurationPk) {
  if (!Number.isInteger(metaverseConfigurationId) || metaverseConfigurationId <= 0) {
    throw new OfficeChromeMountError(
      `The office chrome (presence mode and incoming rings) needs the ${METAVERSE_APP} Configuration this q3po install uses, `
      + `but the root app reported ${JSON.stringify(metaverseConfigurationId)}. Run App::install("Q3po") so the Metaverse dependency is recorded.`,
    );
  }
  if (!q3poConfigurationPk || !(Number(q3poConfigurationPk.id) > 0)) {
    throw new OfficeChromeMountError(
      "The office chrome (event-starting notices) needs this install's Q3po Configuration, "
      + `but the root app reported ${JSON.stringify(q3poConfigurationPk)} as its current configuration pk.`,
    );
  }
  return {
    ...pageContexts,
    metaverseConfig: { entityType: "Configuration", pk: { id: metaverseConfigurationId }, appName: METAVERSE_APP },
    q3poConfig: { entityType: "Configuration", pk: q3poConfigurationPk, appName: "Q3po" },
  };
}
